import React from "react";
import { Modal } from "react-bootstrap";

const DeleteModal = ({ toggleModal }) => {
  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Hapus Pertemuan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fw-bold text-center">
          Apakah Anda yakin akan menghapus data ini?
        </p>
        <button className="btn w-100 btn-danger mt-3" onClick={closeModal}>
          Hapus
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
